<template>
  <div id="index" ref="index">
    <!-- kv -->
    <kv :banner="banner"></kv>
    <div class="wrap">
      <section class="message bg-primary-white">
        <!-- 最新消息 type:1 -->
        <div
          class="news container"
          data-aos="fade-up"
          data-aos-anchor="#header"
          data-aos-anchor-placement="top-center"
          data-aos-once="true"
        >
          <h4 v-if="news.length > 0" class="section-title m-0 text-center mb-40">
            <span class="bg-primary-white px-3">最新消息</span>
          </h4>
          <div class="row d-flex" v-masonry transition-duration="0.3s" item-selector=".item">
            <div
              v-masonry-tile
              class="item col-md-6 col-12 mt-30"
              v-for="(item, index) in news"
              :key="index"
            >
              <ContentBox
                :type="1"
                :id="item.id"
                :title="item.title"
                :brief="item.brief"
                :time="item.publish_at"
                :image="item.media.data"
                :video="item.youtube"
                :path="item.no"
              />
            </div>
          </div>
        </div>
        <!-- 活動記錄 type:2 -->
        <div
          class="activity container pt-40 pb-20"
          data-aos="fade-up"
          data-aos-anchor="#header"
          data-aos-anchor-placement="top-center"
          data-aos-once="true"
        >
          <h4 v-if="activities.length > 0" class="section-title m-0 text-center mb-40">
            <span class="bg-primary-white px-3">活動記錄</span>
          </h4>
          <div class="row d-flex" v-masonry transition-duration="0.3s" item-selector=".item">
            <div
              v-masonry-tile
              class="item col-md-6 col-12 mt-25"
              v-for="(item, index) in activities"
              :key="index"
            >
              <ContentBox
                :type="2"
                :id="item.id"
                :title="item.title"
                :brief="item.brief"
                :time="item.publish_at"
                :image="item.media.data"
                :video="item.youtube"
                :path="item.no"
              />
            </div>
          </div>
        </div>
      </section>
      <!-- 服務項目 -->
      <section class="service bg-white">
        <div class="container" data-aos="fade-left" data-aos-once="true">
          <h4 class="section-title m-0 text-center mb-20">
            <span class="bg-white px-3">服務項目</span>
          </h4>
          <div class="row">
            <div
              v-for="(item, index) in services"
              :key="index"
              class="col-lg-3 col-md-4 col-6 mt-20 h-100"
              data-aos="flip-up"
              data-aos-once="true"
              :data-aos-delay="index*200"
            >
              <router-link :to="{name:'service', params:{id:item.no}}">
                <div class="card p-10 d-flex flex-column align-items-center border-0 h-100">
                  <div class="card-img-top d-flex align-items-center justify-content-center">
                    <img
                      v-if="item.media.data.length>0"
                      v-lazy="item.media.data[0].medium"
                      class="rounded"
                      :key="item.id"
                    />
                  </div>
                  <div class="card-body">
                    <h4 v-if="item.title === '社區整合型服務中心' " class="card-title text-primary text-center"> 社區整合型<br>服務中心 </h4>
                    <h4 v-else class="card-title text-primary text-center">{{ item.title }}</h4>
                    <p
                      class="card-desc d-none d-md-block card-text text-center my-10"
                    >{{ item.brief }}</p>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </section>
      <!-- 捐款捐物 -->
      <section class="donation bg-primary-white">
        <div class="container" data-aos="fade-right" data-aos-once="true">
          <h4 class="section-title m-0 text-center mb-40">
            <span class="bg-primary-white px-3">捐款捐物</span>
          </h4>
          <div class="row">
            <div
              v-for="(item, index) in donation"
              :key="index"
              class="col-4 mt-20"
              data-aos="flip-up"
              data-aos-once="true"
              :data-aos-delay="index*200"
            >
              <div class="card p-1 d-flex flex-column align-items-center border-0 bg-transparent">
                <router-link :to="{name:'donation', params:{id:item.link}}">
                  <div
                    class="card-img-top d-flex align-items-center justify-content-center mx-auto"
                  >
                    <img v-lazy="item.img" :key="index" class="rounded" />
                  </div>
                  <div class="card-body">
                    <h4 class="card-title text-font text-center mb-3">{{ item.title }}</h4>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- 交通資訊 -->
    <section class="transport bg-white" ref="transport">
      <div class="container" data-aos="fade-left" data-aos-once="true">
        <h4 class="section-title m-0 text-center mb-20">
          <span class="bg-white px-3">交通資訊</span>
        </h4>
        <div class="google-map w-100 mb-3">
          <iframe
            v-if="map"
            :src="iframe"
            class="w-100"
            height="400"
            frameborder="0"
            style="border:0;"
            allowfullscreen
          ></iframe>
        </div>
        <h6 class="mt-40 mb-20">
          地址：243新北市泰山區新生路4號
          <br />公車：從捷運丹鳳站可搭乘637 638 801公車 / 從台北車站搭乘F216免費公車到明志國小站
        </h6>
      </div>
    </section>
    <div class="back d-flex align-items-center justify-content-center" @click="scrollToTop">
      <i class="material-icons">expand_less</i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ContentBox from '@/components/content-box.vue';
import kv from '@/components/kv.vue';

export default {
  name: 'Home',
  metaInfo: {
    title: '',
  },
  components: {
    ContentBox,
    kv,
  },
  data() {
    return {
      banner: [],
      // 9
      news: [],
      // 10
      activities: [],
      // 11
      services: [],
      donation: [
        {
          img: '/donation-1.svg',
          title: '立即捐款',
          link: 'method',
        },
        {
          img: '/donation-2.svg',
          title: '物資捐助',
          link: 'supplies',
        },
        {
          img: '/donation-3.svg',
          title: '捐助名冊',
          link: 'list',
        },
      ],
      map: false,
      iframe: `https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7229.360858613198!2d121.42818699999998!3d25.044917!3m2!1i1024!2i768!4f13.
          1!3m3!1m2!1s0x3442a7c68120d109%3A0x4b8712a8c8131d6c!2zMjQz5paw5YyX5biC5rOw5bGx5Y2A5paw55Sf6LevNOiZnw
          !5e0!3m2!1szh-TW!2stw!4v1571987872216!5m2!1szh-TW!2stw`,
    };
  },
  computed: {
    ...mapGetters(['screenWidth']),
    kv_id() {
      return this.screenWidth >= 576 ? 1 : 2;
    },
  },
  methods: {
    getBanner() {
      const url = `/banner/${this.kv_id}`;
      this.axios
        .get(url)
        .then((response) => {
          this.banner = response.data.data.file.data;
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
        });
    },
    getNews() {
      const url = '/article';
      const params = {
        search: 9,
        searchFields: 'category_id',
        // orderBy: 'active_at',
        sortedBy: 'desc',
        limit: 6,
      };
      this.axios
        .get(url, { params })
        .then((response) => {
          this.news = response.data.data.length <= 4 ? response.data.data : response.data.data.slice(0, 4);
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
        });
    },
    getActivities() {
      const url = '/article';
      const params = {
        search: 10,
        searchFields: 'category_id',
        // orderBy: 'active_at',
        sortedBy: 'desc',
        limit: 6,
      };
      this.axios
        .get(url, { params })
        .then((response) => {
          this.activities = response.data.data.length <= 4 ? response.data.data : response.data.data.slice(0, 4);
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
        });
    },
    getServices() {
      const url = '/article';
      const params = {
        search: 11,
        searchFields: 'category_id',
        orderBy: 'active_at',
        sortedBy: 'desc',
        limit: 15,
      };
      this.axios
        .get(url, { params })
        .then((response) => {
          this.services = response.data.data;
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
        });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.getBanner();
    this.getNews();
    this.getActivities();
    this.getServices();
    setTimeout(() => {
      this.map = true;
    }, 1000);
    if (this.$route.params.id) {
      const target = this.$route.params.id;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs[target].scrollIntoView();
        }, 800);
      });
    } else {
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToTop();
        }, 500);
      });
    }
  },
  watch: {
    kv_id() {
      this.getBanner();
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/all.scss';

#index {
  @media (max-width: 575px) {
    width: calc(100vw - 5px);
    overflow-x: hidden;
  }
  .wrap {
    position: relative;
    @media (min-width: 1024px) {
      &::before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-image: url('~@/assets/images/bg-circle-left.svg'),
          url('~@/assets/images/bg-circle-right.svg');
        background-size: 170px auto, 170px auto;
        background-repeat: repeat-y, repeat-y;
        background-position: left top, right top;
      }
    }
  }
  section:not(.hooper):not(.kv) {
    min-height: 450px;
    padding: 40px 0;
    a {
      color: #000000;
      text-decoration: none;
    }
    .section-title {
      color: $secondary;
      position: relative;
      z-index: 1;
      &::before {
        position: absolute;
        content: '';
        height: 5px;
        background-color: $primary;
        opacity: 0.3;
        right: 0;
        left: 0;
        top: 12px;
        z-index: -1;
      }
    }
    // 最新消息 活動記錄
    &.message {
      background: lighten($primary-white, 8%);
    }
    // 服務項目
    &.service {
      .card {
        transition: 0.3s ease-out;
        border-radius: 5px;
        &:hover {
          box-shadow: 0px 0px 8px lighten($secondary-light, 22%);
        }
        .card-img-top {
          width: 60%;
          max-width: 150px;
          max-height: 150px;
          overflow: hidden;
          img {
            width: 100%;
            height: auto;
          }
        }
        .card-body {
          padding: 0;
          .card-title {
            padding: 20px 0;
            margin: 0;
            letter-spacing: 3px;
            overflow: hidden;
            // white-space: nowrap;
            text-overflow: ellipsis;
          }
          .card-desc {
            color: $secondary;
            letter-spacing: 2px;
            display: -webkit-box !important;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
          }
        }
      }
    }
    // 捐款
    &.donation {
      .card {
        a {
          color: $secondary;
          text-decoration: none;
        }
        .card-img-top {
          width: 80%;
          max-width: 200px;
          max-height: 200px;
          overflow: hidden;
          img {
            width: 100%;
            height: auto;
          }
        }
      }
    }
    &.transport {
      padding-bottom: 80px;
      background-image: url('~@/assets/images/leaf.svg'), url('~@/assets/images/leaf2.svg');
      background-size: 170px auto;
      background-repeat: no-repeat;
      background-position: left bottom, right bottom;
      h6 {
        padding: 10px;
        background-color: rgba(255, 255, 255, 0.5);
        line-height: 1.75em;
      }
    }
  }
}
</style>
